import { Box, Text, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import s from '../whoisResultsPage.scss';
export const WhoisPageError = _ref => {
  let {
    onRetry,
    message
  } = _ref;
  const {
    t,
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    className: s.pageErrorContainer,
    direction: "vertical",
    align: "center",
    verticalAlign: "middle",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, t('domain_search_gate.whois_results.error.full_page.connection.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: message,
    components: [/*#__PURE__*/React.createElement("br", null)]
  })), /*#__PURE__*/React.createElement(TextButton, {
    prefixIcon: /*#__PURE__*/React.createElement(Refresh, null),
    onClick: onRetry
  }, t('domain_search_gate.whois_results.error.full_page.connection.cta')));
};
//# sourceMappingURL=WhoisPageError.js.map